{
    "Accessibility menu": "menu dostępności",
    "Reset settings": "Resetuj ustawienia",
    "Close": "Zamknij",
    "Content adjustments": "Dostosowania Treści",
    "Navigation adjustments": "Dostosowania Nawigacji",
    "Align Left": "cya11yrównaj do Lewej",
    "Adjust Font Size": "Dostosuj Rozmiar Czcionki",
    "Highlight Title": "Podświetl Tytuł",
    "Highlight Links": "Podświetl Linki",
    "Readable Font": "Czytelna Czcionka",
    "Colour adjustments": "Dostosowania Kolorów",
    "Dark Contrast": "Ciemny Kontrast",
    "Light Contrast": "Jasny Kontrast",
    "High Contrast": "cya11ysoki Kontrast",
    "High Saturation": "cya11ysoka Nasycenie",
    "Low Saturation": "Niskie Nasycenie",
    "Monochrome": "Monochromatyczny",
    "Tools": "Narzędzia",
    "Reading Guide": "Przewodnik Czytania",
    "Stop Animations": "Zatrzymaj Animacje",
    "Big Cursor": "Duży Kursor",
    "Increase Font Size": "Zwiększ Rozmiar Czcionki",
    "Decrease Font Size": "Zmniejsz Rozmiar Czcionki",
    "Letter Spacing": "Odstęp Liter",
    "Line Height": "cya11ysokość Linii",
    "Font Weight": "Grubość Czcionki",
    "Dyslexia Font": "Czcionka dla Dysleksji",
    "Language": "Język",
    "Accessibility widget": "Otwórz menu dostępności",
    "Accessibility Profiles": "Profile Dostępności",
    "Cognitive Disability": "Niepełnosprawność Poznawcza",
    "Seizure Safe": "Bezpieczny dla Padaczki",
    "Accessibility statement": "Oświadczenie o Dostępności"
}